import React from 'react'

export default function NoEmployeeData() {
  return (
    <div className="flex h-full items-center justify-center">
      <p className="text-lg font-medium text-gray-500">Employee not found</p>
    </div>
  )
}
